import { Chip, ChipProps } from "@mui/material";
import * as React from "react";

interface CustomChipsProps extends ChipProps {
  label: string;
  type?:
    | "success"
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "warning";
  variant?: "filled" | "outlined";
  size?: "small" | "medium";
  fullWidth?: boolean;
  onClick?: any;
}

const CustomChip = ({
  label,
  type = "success",
  size = "small",
  variant = "filled",
  fullWidth = false,
  onClick,
  ...props
}: CustomChipsProps) => {
  // console.log(type, label);
  const colors = {
    success: {
      color: "#7AD98C",
      bgColor: "#EDF7EE",
    },
    warning: {
      color: "#DBBD5B",
      bgColor: "#FFEEB7",
    },
    primary: {
      color: "#FFA33F",
      bgColor: "#FFF0DF",
    },
    error: {
      color: "red",
      bgColor: "#F6D7D7",
    },
    info: {
      color: "black",
      bgColor: "#B3B3B3",
    },
  };
  const colorHash = colors[type];

  return (
    <Chip
      label={label}
      size={size}
      variant={variant}
      sx={{
        '&.MuiChip-root':{
          px: 1,
          textTransform: "capitalize",
          backgroundColor: colorHash?.bgColor,
          color: colorHash?.color,
          fontFamily: "QuicksandBold",
          width: fullWidth ? "100%" : undefined,
          borderRadius: '16px',

          // Temp code needed until this fix https://trello.com/c/Rza4dlgx/1102-mui-class-issue
          position: 'relative',
          fontSize: '0.8125rem',
          textDecoration: 'none',
          border: 0,
          padding: 0,
          verticalAlign: 'middle',
          boxSizing: 'border-box',
          userSelect: 'none',
          transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
          display: 'inline-flex'
        },
        "&:hover": {
          backgroundColor: colorHash?.bgColor,
          boxShadow: "none",
        },
      }}
      onClick={onClick}
    />
  );
};

export default CustomChip;
